import tunnel from 'tunnel-rat';

const ui = tunnel();

export default ui;
